import { useNavigate } from "#src/Routers/hooks";
import { Stack } from "@phosphor-icons/react";
import { Button, EmptyState, Panel } from "@validereinc/common-components";
import type { FlowType } from "@validereinc/domain";
import React from "react";
import { useParams } from "react-router";
import { FlowEditRoute } from "../edit";
import { FlowEquipmentTable } from "./FlowEquipmentTable";
import { FlowFacilityTable } from "./FlowFacilityTable";
import { FlowFlowsTable } from "./FlowFlowsTable";

export const FlowUpstreamPanel = ({
  flow,
  isLoading,
}: {
  flow?: FlowType;
  isLoading: boolean;
}) => {
  const { flowId } = useParams<{ flowId: string }>();
  const navigate = useNavigate();

  const hasNoUpstreams =
    !isLoading &&
    !flow?.upstream_facility &&
    !flow?.upstream_equipment &&
    !flow?.upstream_flows?.length;

  return (
    <Panel
      loaded={!isLoading}
      title="Origin"
      actionRow={
        <Button
          onClick={() => {
            navigate(FlowEditRoute.toLinkParts({ pathParams: { flowId } }));
          }}
        >
          Edit Connections
        </Button>
      }
    >
      {flow?.upstream_facility ? (
        <FlowFacilityTable
          variant="upstream"
          flow={flow}
          isLoading={isLoading}
        />
      ) : null}

      {flow?.upstream_equipment ? (
        <FlowEquipmentTable
          variant="upstream"
          flow={flow}
          isLoading={isLoading}
        />
      ) : null}

      {flow?.upstream_flows?.length ? (
        <FlowFlowsTable
          variant="upstream"
          flow={flow}
          isLoading={isLoading}
        />
      ) : null}

      {hasNoUpstreams && (
        <EmptyState
          title="No Upstream Assets"
          suggestion="Edit connections to add upstream assets"
          icon={<Stack />}
        />
      )}
    </Panel>
  );
};
